import { Box, Typography, useMediaQuery } from "@mui/material"
import { theme } from "../Theme";

export const CoachingGoodToKnow: React.FC = () => {
    const sm = useMediaQuery(theme.breakpoints.up('sm'));
    const fontSize = sm? '1rem':'0.8rem';

    return  (  
        <Box className="descriptionDiv bulletList" style={{minHeight: '400px'}}>
            <Typography variant={sm?"h5":'h6'} color="primary" component="h2" textAlign='center'>
                <strong>Good to know</strong>
            </Typography>
            <ul style={{paddingTop:"1rem", textAlign: 'left', fontSize}}>
                <li>Coaching ist mentale Arbeit</li>
                <li>Wir werden alt bekannte Gedankensätze wie z.B. „es wird der schönste Tag in meinem Leben“ erneuern</li>
                <li>Wir werden über emotionale Themen sprechen und ich bitte Dich um eine notwendige Offenheit dafür </li>
                <li>Du wirst nicht aus dem ersten Coaching gehen und denken „alles ist geregelt und cool“, denn mentale Arbeit ist ein langer Prozess </li>
                <li>Ich freue mich unglaublich auf Dich und das Coaching mit Dir! </li>
            </ul>
        </Box>
    )
}
